import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { CreateCommunicationTemplatePage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

const createTemplateSearchSchema = z.object({
  duplicateFrom: z.string().uuid().optional(),
})

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/templates/new"
)({
  component: () => (
    <AuthorizationGate
      resource={Resource.COMMUNICATION_TEMPLATES}
      action={Action.CREATE}
    >
      <CreateCommunicationTemplatePage />
    </AuthorizationGate>
  ),
  validateSearch: createTemplateSearchSchema,
})
